import PropTypes from 'prop-types';
import DropDownSelectOptions from './DropDownSelectOptions';
import { size } from '@/helpers/lodash';
import CaretIcon from '@/components/component-library/Icon/types/Caret';
import Text, { FONT_SIZE_070 } from '@/components/component-library/Text';
import { classes } from '@/helpers/styling';
import useFocusAndBlur from '@/hooks/browser/useFocusAndBlur';

const DropDownSelect = ({
  options,
  onOpen,
  onClose,
  onClickOption,
  open,
  selectedId,
  placeholder,
  loading,
  disabled,
  className,
  disableArrow,
  isSelectable
}) => {
  const {
    ref,
    onBlur,
    focus
  } = useFocusAndBlur({ blurCallback: onClose });

  const currentValue = selectedId && size(options)
    ? (options.find((o) => o.id.toString() === selectedId.toString()) || {}).value
    : placeholder;

  const handleClickSelect = () => {
    if (loading || disabled || open) {
      onClose();
    } else {
      focus();
      onOpen();
    }
  };
  
  return (
    <div
      className={ classes(
        'drop-down',
        {
          '--is-open': open,
          '--is-disabled': disabled || loading,
          '--is-loading': loading
        },
        className
      ) }
      onBlur={ onBlur }
      onClick={ handleClickSelect }
      ref={ ref }
      tabIndex={ 0 }
    >
      <div className='drop-down__current-value'>
        <Text
          bold
          className='drop-down__current-value-text'
          size={ FONT_SIZE_070 }
          useHeaderFont
        >
          { currentValue }
        </Text>
        { !disableArrow && <CaretIcon /> }
      </div>
      <div className='drop-down__options-wrapper'>
        <DropDownSelectOptions
          isSelectable={ isSelectable }
          onClickOption={ onClickOption }
          onClose={ onClose }
          open={ open }
          options={ options }
          selectedId={ selectedId }
        />
      </div>
    </div>
  );
};

DropDownSelect.propTypes = {
  options: PropTypes.array,
  onOpen: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onClickOption: PropTypes.func.isRequired,
  open: PropTypes.bool,
  selectedId: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  disableArrow: PropTypes.bool,
  className: PropTypes.string,
  isSelectable: PropTypes.bool
};

DropDownSelect.defaultProps = {
  options: [],
  open: false,
  selectedId: null,
  loading: false,
  disabled: false,
  disableArrow: false,
  className: '',
  isSelectable: false
};

export default DropDownSelect;